import Reveal from "./Reveal";
import { useLanguage } from "../context/LanguageContext";

const Intro = () => {
  const { t } = useLanguage();
  const intro = t.intro;

  return (
    <section className="relative overflow-hidden py-24 sm:py-32" data-testid="intro-section">
      <div className="pointer-events-none absolute end-[-8%] top-24 h-[420px] w-[420px] rounded-full bg-amber-100/50 blur-3xl" />
      <div className="relative mx-auto max-w-7xl gap-16 px-4 sm:px-8 lg:grid lg:grid-cols-[0.9fr_1.1fr]">
        <div className="mb-14 lg:mb-0">
          <div className="lg:sticky lg:top-28">
            <Reveal>
              <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-amber-600">
                {intro.overline}
              </p>
              <h2 className="mt-5 font-heading text-3xl font-extrabold leading-[1.12] tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
                <span className="block text-slate-400">{intro.statement1}</span>
                <span className="mt-2 block bg-gradient-to-r from-sky-600 to-amber-500 bg-clip-text text-transparent">
                  {intro.statement2}
                </span>
              </h2>
              <p className="mt-6 max-w-md text-base leading-relaxed text-slate-600 sm:text-lg">
                {intro.lead}
              </p>
            </Reveal>
          </div>
        </div>

        <div>
          {intro.chapters.map((c, i) => (
            <Reveal key={c.num} delay={i * 0.06}>
              <article
                data-testid={`intro-chapter-${c.num}`}
                className="group relative border-t border-sky-100 py-10 transition-colors first:border-t-0 first:pt-0 hover:border-amber-200 sm:py-12"
              >
                <div className="flex gap-6 sm:gap-10">
                  <span className="font-heading text-4xl font-extrabold text-sky-100 transition-colors duration-300 group-hover:text-amber-300 sm:text-6xl">
                    {c.num}
                  </span>
                  <div>
                    <h3 className="font-heading text-xl font-bold leading-snug text-slate-900 transition-colors duration-300 group-hover:text-sky-700 sm:text-2xl">
                      {c.title}
                    </h3>
                    <p className="mt-3 max-w-xl text-sm leading-relaxed text-slate-600 sm:text-base">
                      {c.desc}
                    </p>
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Intro;
